import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectTypeCostAvailableColumns } from './api';

export const path = '/defect-type/cost/list';

const PageDefectTypeCost: React.FC = (props) => {
  const DefectTypeCost = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDefectTypeCostAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DefectTypeCost {...props} />;
};

export default PageDefectTypeCost;
